import { TextField } from '@ui/field-text';
import { IconSearch } from '@ui/icons';
import styles from './styles.module.css';

export const StorageSearchField = () => (
  <TextField
    className={styles.search}
    leftSide={IconSearch}
    placeholder="область, регион или координаты"
  />
);
